import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import Pricing from './Pricing';
import NoData from '../../CustomizedComponents/DisplayData/NoData';

const PricingWrapper = (
  {
    pricing,
    loading,
    error,
    handlers,
    editable,
    setEditable,
    loaders,
    errors,
  },
) => {
  const {
    eletricCommodity,
    gasTheCommodity,
    gasCzvtpCommodity,
  } = pricing;

  const noData = 'app.dataTable.body.noData';
  const showNothingToDisplay = !eletricCommodity && !gasTheCommodity && !gasCzvtpCommodity && !loading && !error;
  const showError = !!error;
  const showBody = eletricCommodity && gasTheCommodity && gasCzvtpCommodity && !error;

  return (
    <>
      {showNothingToDisplay && <NoData><FormattedMessage id={noData} /></NoData>}
      {showError && <NoData><FormattedMessage id={noData} /></NoData>}
      {showBody &&
      <Pricing
        pricing={pricing}
        handlers={handlers}
        editable={editable}
        setEditable={setEditable}
        loaders={loaders}
        errors={errors}
      />}
    </>
  );
};

PricingWrapper.propTypes = {
  id: PropTypes.any,
  pricing: PropTypes.any,
  loading: PropTypes.bool,
  error: PropTypes.string,
  handlers: PropTypes.object,
  editable: PropTypes.bool,
  setEditable: PropTypes.func,
  loaders: PropTypes.object,
  errors: PropTypes.object,
};


export default PricingWrapper;
